// URLs for the Lists tab (lists have no type since Trello UMndrjdk):
//   /lists/all                   all lists
//   /lists/all/new               new list
//   /lists/all/:listId           a list's items
//   /lists/all/:listId/add       add an item to that list
// Categories (/lists/categories[/add]) use useHubScreen like other hubs.
export const LISTS_TAB = 'all';

export const parseListsPath = (pathname) => {
  const [, , subTab, first, second] = pathname.split('/');
  if (!first)              return { subTab, screen: 'list' };
  if (first === 'new')     return { subTab, screen: 'new-list' };
  if (second === 'add')    return { subTab, screen: 'add', listId: first };
  return { subTab, screen: 'items', listId: first };
};

// listsPathFor builds the URL for a screen of a list tab.
export const listsPathFor = (subTab, screen, listId) => {
  const base = `/lists/${subTab}`;
  if (screen === 'new-list') return `${base}/new`;
  if (screen === 'items')    return `${base}/${listId}`;
  if (screen === 'add')      return `${base}/${listId}/add`;
  return base;
};
